import React from 'react';

const PinnedSessionsGrid = ({ pinnedSessions }) => {
  // Phase 1: returns null when empty (no pin management UI yet)
  if (!pinnedSessions || pinnedSessions.length === 0) return null;
  return null;
};

export default PinnedSessionsGrid;
